import type { MailboxInfo } from 'owa-client-types';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import getCalendarCloudSettings from './getCalendarCloudSettings';

/**
 * Gets the value for the EnableOnlineMeetingsByDefault cloud setting
 */
export default function getEnableOnlineMeetingsByDefaultCloudSetting(
    mailboxInfo: MailboxInfo
): boolean | undefined {
    const accountSettings = getCalendarCloudSettings(mailboxInfo);
    const enableOnlineMeetingSetting = accountSettings.get(
        CalendarCloudSettingType.EnableOnlineMeetingsByDefault.toLowerCase()
    );

    return enableOnlineMeetingSetting != null ? !!enableOnlineMeetingSetting.value : undefined;
}
